export const environment = {
    production: true,
    bankCardApiUrl: 'https://api.billtexting.com/',
    idealTimeOutError: 1800000 //30*60*1000
};
